
import Debug from './lib/debug/Debug';
import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { localeReducer } from 'react-localize-redux';
import { reducer as beesReducer, middleware as beesMiddleware } from 'redux-bees';

import * as Reducers from './reducers'

let store;
const reducer = combineReducers({
  ...Reducers,
  routing: routerReducer,
  form: formReducer,
  locale: localeReducer,
  bees: beesReducer,
});
if(Debug.activated()) {
  store = createStore(
    reducer,
    {},
    compose(
      applyMiddleware(thunk, beesMiddleware()),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
    )
  );
} else {
  store = createStore(
    reducer,
    {},
    compose(
      applyMiddleware(thunk, beesMiddleware()),
       window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
    )
  );
}
export default store;



// WEBPACK FOOTER //
// ./src/Store.js